import { render, staticRenderFns } from "./QAManage.vue?vue&type=template&id=8d45ea66&scoped=true"
import script from "./QAManage.vue?vue&type=script&lang=js"
export * from "./QAManage.vue?vue&type=script&lang=js"
import style0 from "./QAManage.vue?vue&type=style&index=0&id=8d45ea66&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d45ea66",
  null
  
)

export default component.exports